import StringExtensions from "./extensions/string.js";
StringExtensions();

// Lazysizes
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

// Lottieplayer
import "@lottiefiles/lottie-player";

import DateFns from "./date-fns/imports.js";
DateFns();

// Alpine bootup
import Alpine from "./alpine/imports.js";
Alpine();

window.getVerificationToken = () => ({
    'X-CSRF-TOKEN': document.getElementsByName('__RequestVerificationToken')[0].value
});

import { ValidationService } from 'aspnet-client-validation'
window.aspnetValidation = { ValidationService };

import { GSearchUI } from '@dataforsyningen/gsearch-ui'
customElements.define('g-search', GSearchUI)